module.exports = ".modal-dialog {\r\n\twidth: 100%;\r\n}\r\n"